<script>
  export let size;
  export let style = "";
</script>

<svg
  width={size}
  height={size}
  {style}
  class="icon"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 21.53 22.06"
  ><defs
    ><style>
      .impact {
        fill: #f0b64f;
      }
      .impact-off {
        fill: #010101;
      }
    </style></defs
  ><g id="Layer_2" data-name="Layer 2"
    ><g id="KEY"
      ><ellipse
        class="impact"
        cx="10.77"
        cy="11.03"
        rx="10.77"
        ry="11.03"
      /><polygon
        class="impact-off"
        points="11.73 4.58 11.73 8.55 7.85 8.55 7.85 12.52 3.98 12.52 3.98 16.5 7.85 16.5 15.75 16.5 15.75 8.55 15.75 4.58 11.73 4.58"
      /></g
    ></g
  ></svg
>
